import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

type UseTenantGroupsQueryOptions = {
  enabled?: boolean;
};

export function useTenantGroupsQuery(options?: UseTenantGroupsQueryOptions) {
  const { user } = useAuth();
  const isEnabled = (options?.enabled ?? true) && Boolean(user);

  return useQuery({
    queryKey: tenantQueryKeys.groups(),
    enabled: isEnabled,
    queryFn: () => userService.listGroups(),
  });
}
